"use client";

import { useMutation } from "@tanstack/react-query";
import { useRouter } from "next/navigation";
import type { CreateInquiryRequest } from "cmw-client";
import { useDrawer } from "@/components/drawer";
import { toast } from "@/components/toast";
import { browserCmw } from "@/lib/ky/browser";
import { getApiErrorMessage } from "@/lib/ky/error-message";
import { routes } from "@/lib/routes";

/**
 * Sends the "Contact Me" form (`POST /practitioners/:username/inquiries`), closes the drawer and
 * routes to `/inquiry-sent` on success. Unauthenticated — a directory visitor has no session.
 */
export function useSubmitInquiry(
  username: string,
  practitionerName: string,
  takeTurnstileToken: () => Promise<string>,
) {
  const { forceCloseDrawer } = useDrawer();
  const router = useRouter();

  return useMutation({
    mutationFn: async (input: CreateInquiryRequest) =>
      browserCmw.inquiries.create(username, input, await takeTurnstileToken()),
    onSuccess: () => {
      forceCloseDrawer();
      router.push(`${routes.inquirySent.url}?name=${encodeURIComponent(practitionerName)}`);
    },
    onError: async (error) => {
      toast.error(await getApiErrorMessage(error, "Something went wrong sending your request. Please try again."));
    },
  });
}
